import axios from "axios";
import Session from "../helpers/SessionHelper";
import { PRECIP_DATA } from "../../src/configurations/Urls";

const PrecipService = {
  async getPrecipData(startDate, endDate) {
    if (!startDate && !endDate) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(
      `${PRECIP_DATA}?start_date=${startDate}&end_date=${endDate}`,
      { headers: headers }
    );
    return response;
  },
};
export default PrecipService;
